import React, { useCallback, useEffect, useState } from 'react';
import '../../src/assets/AdminCss/CricketScoreboard.css'; // Import the CSS file
import axios from 'axios';
import { base_url } from '../context/Authcontext';

const CricketScoreboard = () => {
  const [team1Score, setTeam1Score] = useState({ runs: 0, wickets: 0, overs: 0, balls: 0 });
  const [team2Score, setTeam2Score] = useState({ runs: 0, wickets: 0, overs: 0, balls: 0 });
  const [currentRunRate, setCurrentRunRate] = useState({ team1: 0.00, team2: 0.00 });
  const [currentOver, setCurrentOver] = useState([]);
  const [matches, setMatches] = useState([]);
  const [battingTeamOvers, setBattingTeamOvers] = useState(0);

  const selected1 = sessionStorage.getItem('runner1');
  const selected2 = sessionStorage.getItem('runner2');

  // Function to calculate current run rate based on runs and overs
  const calculateRunRate = (runs, overs, balls) => {
    const totalOvers = overs + (balls / 6);
    return totalOvers > 0 ? (runs / totalOvers).toFixed(2) : "0.00";
  };

  const parseCurrentOverBalls = (lastData) => {
    try {
      if (!lastData) return [];

      const parts = lastData.split('|');
      if (parts.length === 0) return [];

      const ballsSection = parts[0].split('~');
      if (ballsSection.length < 3) return [];

      // Get the current over balls and filter out any empty entries
      const ballsData = ballsSection[2].trim().split(' ').filter(ball => ball !== '');

      return ballsData;
    } catch (error) {
      console.error("Error parsing current over balls:", error);
      return [];
    }
  };

  const score = useCallback(async () => {
    const eventid = sessionStorage.getItem('eventid');
    try {
      const response = await axios.post(base_url + '/api/webapi/scoreboard',
        { eventid },
        { headers: { 'content-type': 'application/json' } }
      );
      const matchData = response?.data.result;

      if (matchData) {
        const matchParseData = JSON.parse(matchData);

        // Extract home and away team details
        const homeTeam = matchParseData.h;
        const awayTeam = matchParseData.a;

        const isHomeBatting = matchParseData.tw === "h";  // Check if home team is batting
        const isAwayBatting = matchParseData.tw === "a";  // Check if away team is batting

        // Append * to the batting team
        const homeTeamDisplay = isHomeBatting ? `${homeTeam}*` : homeTeam;
        const awayTeamDisplay = isAwayBatting ? `${awayTeam}*` : awayTeam;

        if (isHomeBatting) {
          setBattingTeamOvers(matchParseData.hs[0].o);
        } else {
          setBattingTeamOvers(matchParseData.as[0].o);
        }

        // Process and structure the match data
        const formattedMatch = {
          e: matchParseData.e,
          en: matchParseData.en,
          t: matchParseData.t,
          mf: matchParseData.mf,
          h: homeTeamDisplay,
          a: awayTeamDisplay,
          hs: matchParseData.hs[0], // Home team score data
          as: matchParseData.as[0], // Away team score data
          s: matchParseData.s,
          m: matchParseData.m.replace("**|", ""), // Remove unnecessary symbols
          expanded: true,
        };

        // Set team 1 and team 2 score
        setTeam1Score({
          runs: formattedMatch.hs.r,
          wickets: formattedMatch.hs.w,
          overs: formattedMatch.hs.o,
          balls: formattedMatch.hs.o * 6, // balls calculation
        });

        setTeam2Score({
          runs: formattedMatch.as.r,
          wickets: formattedMatch.as.w,
          overs: formattedMatch.as.o,
          balls: formattedMatch.as.o * 6, // balls calculation
        });

        const currentRunRate = {
          team1: calculateRunRate(formattedMatch.hs.r, formattedMatch.hs.o, formattedMatch.hs.w),
          team2: calculateRunRate(formattedMatch.as.r, formattedMatch.as.o, formattedMatch.as.w),
        };
        setCurrentRunRate(currentRunRate);

        // Process current over balls with improved parsing
        const currentOverBalls = parseCurrentOverBalls(matchParseData.l);
        setCurrentOver(currentOverBalls.reverse());

        setMatches([formattedMatch]);
      }
    } catch (err) {
      console.error("Error fetching score data:", err);
    }
  }, []);

  useEffect(() => {
    // Initial fetch
    score();

    // Set up interval with cleanup
    const intervalId = setInterval(score, 5000);

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, [score]);

  return (
    <div className="scoreboard-container">

      <div className="overAll">
        {/* Main Scoreboard */}
        <div className="row scoreboard-pitch mx-0">
          {/* <div className="field-grid">
            {Array(12).fill().map((_, i) => (
              <div key={i} className="field-grid-line"></div>
            ))}
          </div> */}

          {/* Team 1 */}

          <div className='col-lg-1 col-md-1 col-1 mb-0 px-0'>
            <img src='/assets/paneal_images/batsman-left.svg' className='img-fluid' style={{ width: "62px", height: "95px" }} alt='batsman' />
          </div>

          <div className="col-lg-1 col-md-1 col-1 mb-0 px-0 team-display team-left">
            <div className="team-name1">{matches?.[0]?.h || selected1}</div>
            <div className="team-score">
              {team1Score.runs}/{team1Score.wickets} ({team1Score.overs}ov)
            </div>
            <div className="run-rate">CRR {currentRunRate.team1}</div>
          </div>


          <div className='col-lg-6 col-md-6 col-6 mb-0' style={{ border: "1px solid #fff", height: "106px", borderRadius: "10px" }}>
            {/* Over Display */}
            <div className="over-display">
              <div className="over-label">Over {battingTeamOvers}</div>
              <div className="over-balls">
                {currentOver.length > 0 ? (
                  currentOver.map((ball, idx) => (
                    <div key={idx} className="ball-marker no-score-ball">
                      {ball}
                    </div>
                  ))
                ) : (
                  <div className="no-balls-message">No balls bowled yet</div>
                )}
              </div>
            </div>
          </div>


          {/* Team 2 */}
          <div className="col-lg-1 col-md-1 col-1 ps-xl-0 ps-1 mb-0 pe-0 team-display team-right">
            <div className="team-name1">{matches?.[0]?.a || selected2}</div>
            <div className="team-score">
              {team2Score.runs}/{team2Score.wickets} ({team2Score.overs} ov)
            </div>
            <div className="run-rate">CRR {currentRunRate.team2}</div>
          </div>

          <div className='col-lg-1 col-md-1 col-1 mb-0 px-0'>
            <img src='/assets/paneal_images/baller-right.svg' className='img-fluid' style={{ width: "62px", height: "95px" }} alt='baller' />
          </div>

        </div>
      </div>
    </div>
  );
};

export default CricketScoreboard;